import React, { FC, useState } from "react";
import axios from "axios";
import { Formik, Field, Form } from "formik";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from '../shared/NewconfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const AddNewIndustry: FC = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [redirectAfterModal, setRedirectAfterModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [pendingValues, setPendingValues] = useState<any>(null); // store form values before confirmation

  const callApiAddIndustry = async (values: any) => {
    const url = `${process.env.REACT_APP_API_URL}industries/add-industry`;
    try {
      const response = await axios.post(url, {
        name: values.name,
        industry_icon: values.industry_icon || null,
      });
      if (response.status === 201) {
        setSuccessMessage("Industry added successfully!");
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate("/industries");
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      setFailureMessage("Failed to add industry. Please try again.");
      setShowFailureModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    if (redirectAfterModal && pendingValues) {
      callApiAddIndustry(pendingValues);
      setRedirectAfterModal(false);
      setPendingValues(null);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center py-2">
              <h4>Add New Industry</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{ name: "", industry_icon: "" }}
                validate={(values) => {
                  const errors: any = {};
                  if (!values.name) {
                    errors.name = "Industry name is required";
                  }
                  return errors;
                }}
                onSubmit={async (values, { resetForm }) => {
                  setModalMessage("Are you sure you want to add this industry?");
                  setPendingValues(values); // store form values temporarily
                  setRedirectAfterModal(true);
                  setShowModal(true);
                  resetForm();
                }}
              >
                {({ values, errors, touched, setFieldValue }) => (
                  <Form>
                    <Row className="mb-3">
                      <Col>
                        <label htmlFor="name" className="form-label">
                          Industry Name:
                        </label>
                        <Field
                          name="name"
                          type="text"
                          className={`form-control ${
                            errors.name && touched.name ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Name"
                        />
                        {errors.name && touched.name && (
                          <div className="invalid-feedback">{errors.name}</div>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col>
                        <label htmlFor="industry_icon" className="form-label">
                          Industry Icon (Optional):
                        </label>
                        <Field
                          name="industry_icon"
                          type="text"
                          className="form-control"
                          placeholder="Enter Font Awesome class (e.g., fas fa-industry)"
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success" disabled={!!errors.name}>
                          Add Industry
                        </Button>

                        <Button variant="danger" className="mx-2" onClick={() => navigate("/industries")}>
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Confirmation Modal */}
      <ConfirmationModal
        show={showModal}
        onHide={handleModalClose}
        modalMessage={modalMessage}
        operationType="Confirm"
      />

      <NewconfirmationModal 
        show={showSuccessModal} 
        onHide={() => setShowSuccessModal(false)} 
        modalMessage={successMessage} 
        operationType="Ok" 
        timeoutDuration={3000} 
      />
      
      <AllFailureModal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        modalMessage={failureMessage}  
        operationType="Ok" 
        timeoutDuration={5000}
      />
    </Container>
  );
};

export default AddNewIndustry;
